import styled from "styled-components";
import TextField, { BaseTextFieldProps } from "@mui/material/TextField";

export const StyledTextField = styled(TextField)(({ theme }) => ({
  "& .MuiInputBase-input": {
    backgroundColor: theme.palette.grey[100],
    borderRadius: 16,
    ...theme.typography.body1,
  },
  "& fieldset": {
    border: "none",
  },
  "& .MuiInputLabel-root": {
    ...theme.typography.body2,
    "&.Mui-focused": {
      color: "#404943",
    },
  },
  "& .MuiInputLabel-shrink": {
    color: "#404943",
    paddingTop: 18
  },
}));

export interface TextInputProps extends BaseTextFieldProps {
  label: string;
  value: string;
  onChange: (value: string | number) => void;
  type?: string;
  placeholder?: string;
  fullWidth?: boolean;
  helperText?: string;
  error?: boolean;
}

export type FileUpload = { url: string; file: File };
